import React from 'react'
import PropTypes from 'prop-types'

const DroppableRef = ({ children }) => {
  return <>{children}</>
}

DroppableRef.propTypes = {
  children: PropTypes.element,
  location: PropTypes.string,
}

export default DroppableRef
